<div class="modal-header">
  <button type="button" class="close" ng-click="eImg.close()">&times;</button>
  <h3 class="modal-title">Editar imagem</h3>
</div>
<div class="modal-body text-center">
  <p class="text-cinza" ng-show="eImg.loading">
    <i class="fa fa-spinner fa-pulse fa-fw text-cinza"></i> Carregando...
  </p>
  <canvas id="edit-image-canvas" ng-show="!eImg.loading"></canvas>
</div>
<div class="modal-footer text-right">
  <button type="button" class="btn btn-link" ng-click="eImg.reset()">Limpar</button>
  <button type="button" class="btn btn-white" ng-click="eImg.close()">Cancelar</button>
  <button type="button" class="btn btn-success" ng-click="eImg.save()">Salvar</button>
</div>
